<script>
import axios from "axios";
import { Translator } from 'vue-google-translate';
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:'',
      arrayOfCountries: [
        { code: 'en|en', title: 'English',},
        { code: 'en|fr', title: 'French', },
        { code: 'en|ar', title: 'Arabic', },
        {
          code: 'en|sw',
          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',
          title: 'Kiswahili',
        },
        {
          code: 'en|lg',
          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',
          title: 'Luganda',
        },],
    };
  },
  components: {
    Translator,
  },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box" style="background: #000000;">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="40"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="40"/></span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="60"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="60"/></span>
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars"></i></button>
        <span toggle-class="header-item" class="pt-3  d-none d-lg-block">
          <span class="h4">{{ userData.business }} </span> <br>
          <span class="small"><i class="mdi mdi-map-marker"></i> {{ userData.location }} </span>
        </span>
      </div>
      <div class="d-flex">
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" />
        </b-dropdown>
        <span v-if="userData.permissions['view_reports']==1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content><i class="fas fa-clipboard"></i> Reports<i class="mdi mdi-chevron-down"></i></template>
            <div class="row">
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Patients Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="cashpaymentsreport">Cash Payments</router-link></li>
                    <li><router-link to="cashpaymentsreport">Insurance Invoices</router-link></li>
                    <li><router-link to="personalpaymentsreport">Personal Account Payments</router-link></li>
                    <li><router-link to="departmentanalysisreport">Department Analysis</router-link></li>
                    <li><router-link to="serviceanalysisreport">Service Analysis</router-link></li>
                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Pharmacy Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="pharmacypaymentsreport">Pharmacy Payments</router-link></li>
                    <li><router-link to="purchasebysupplierreport">Purchases Per Supplier</router-link></li>
                    <li><router-link to="pharmacypurchasereport">Pharmacy Purchases</router-link></li>
                    <li><router-link to="productsdemand">Products Demand</router-link></li>
                    <li><router-link to="pharmacybymonthreport">Monthly Analysis</router-link></li>
                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Performance Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="paymentsbyuserreport">Payments Per User</router-link></li>
                    <li><router-link to="workloadbyuserreport">Workload Per User</router-link></li>
                    <li><router-link to="labreport">Lab Performance</router-link></li>
                    <li><router-link to="appointmentsreport">Appointments</router-link></li>
                    <li><router-link to="expensesreport">Expenses Report</router-link></li>
                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Other Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="/diagnosisanalysisreport">Diagnosis Analysis</router-link></li>
                    <li><router-link to="/paymentsbyoptionreport">Payments Per Payment Method</router-link></li>
                    <li><router-link to="/paymentsbymonthreport">Payments Per Month</router-link></li>
                    <li><router-link to="cashflowreport">Income & Expenditure </router-link></li>
                  </ul>
                </div>
            </div> 
          </b-dropdown>
        </span>

        <span v-if="userData.permissions['view_settings']==1">
        <b-dropdown
          variant="black"
          class="dropdown-mega"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-slot:button-content><i class="fas fa-cog"></i> Settings <i class="mdi mdi-chevron-down"></i>
          </template>
          <div class="row">
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">System Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="facilityprofile">Facility Profile</router-link></li>
                  <li><router-link to="services">Facility Services</router-link></li>
                  <li><router-link to="paymentoptions">Payment Options</router-link></li>
                  <li><a href="javascript:void(0);">Family Accounts</a></li>
                  <li><router-link to="diagnosis">Facility Diagnosis</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Pharmacy Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="productitems">Product Items</router-link></li>
                  <li><router-link to="productitemunits">Product Items Units</router-link></li>
                  <li><router-link to="productcategories">Product Categories</router-link></li>
                  <li><router-link to="productunits">Product Units</router-link></li>
                  <li><router-link to="suppliers">Product Suppliers</router-link></li>
                  <li><router-link to="reconcilestock">Reconcile Stock</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Labratory Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="labsamples">Lab Samples</router-link></li>
                  <li><router-link to="testresults">Test Results</router-link></li>
                  <li><router-link to="labsamples">Lab Stock</router-link></li>
                  <li><router-link to="labsamples">Lab Stock Usage</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">User Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="users">System Users</router-link></li>
                  <li><router-link to="roles">System Roles</router-link></li>
                  <li><router-link to="permissions">System Permissions</router-link></li>
                  <li><router-link to="audits">Audit Trails</router-link></li>
                </ul>
              </div>
          </div> 
        </b-dropdown>
        </span>   

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>